import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import apiRequest from "../utils/ApiRequest/apiRequest.js";
import config from "config";
import queryString from "query-string";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "../contexts/userContext/userContext.js";

const { blackfriday } = queryString.parse(window.location.search);
const cookies = new Cookies();
const isTokenExist = cookies.get(config.api.jumbomailApiAuthCookie);

const useBlackFridayUser = () => {
  const [time, setTime] = useState(false);
  const { getUserData, isSubscribed } = useUser();
  const {
    setBlackFridayTime,
    setIsBlackFriday,
    setBlackFridayTimeCookie,
    setCouponCode,
  } = useContent();

  const checkIfUserHaveToSeeIt = async () => {
    const response = await apiRequest(
      "Coupons",
      "CheckSpecialCartCouponForJUMBOpro",
      { userEmail: getUserData().UserName || "" }
    );
    if (response.status === "success") {
      if (response.data.isActive) {
        setBlackFridayTime(response.data.SecondsLeft);
        setTime(response.data.SecondsLeft);
        setIsBlackFriday(response.data.IsBlackFriday);
        setBlackFridayTimeCookie(true);
        setCouponCode(response.data.CouponCode);
      } else {
        setBlackFridayTime(false);
        setTime(false);
        setBlackFridayTimeCookie(false);
      }
    }
  };

  useEffect(() => {
    if (isSubscribed()) {
      setBlackFridayTimeCookie(false);
    }
  }, [isSubscribed()]);

  useEffect(() => {
    if (blackfriday) {
      // end date is 26 of november 2022 23:59:59, calculate the time left in minutes
      const endDate = new Date(2022, 10, 26, 23, 59, 59);
      const now = new Date();
      const timeLeft = Math.floor((endDate - now) / 1000 / 60);
      setBlackFridayTime(timeLeft);
      setTime(timeLeft);
    } else {
      if (isTokenExist) {
        if (getUserData().UserName) {
          checkIfUserHaveToSeeIt();
        }
      } else {
        checkIfUserHaveToSeeIt();
      }
    }
  }, [getUserData().UserName]);

  return time;
};

export default useBlackFridayUser;
